import React, { useCallback, useMemo } from "react";
import { debounce, isNumber } from "lodash";

import { Input, Icon, glyphs } from "@treelab/panda";

import { ITypeOptions, ColumnType } from "../../../../../../types/table-type";
import { IFilterValue } from "../../../../../../types/form-type";

import { isInvalidTypedCharForInput } from "../../../../../../utils/filter_secondary";

import { Container } from "./styled";

interface IProps {
  name: string;
  onChange: (value: { [key: string]: any }) => void;
  typeOptions: ITypeOptions<ColumnType.RATING>;
  value: IFilterValue;
}

const RatingInput: React.FC<IProps> = ({ name, onChange, typeOptions, value: filterValue }) => {
  const { filterString } = filterValue;
  const { ratingMax } = typeOptions;
  const debouncedOnChange = useMemo(() => debounce(onChange, 150), [onChange]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const valueStr = e.target.value;
      const valueNum = Number.parseInt(valueStr, 10);
      if (!isNumber(valueNum) || isNaN(valueNum)) {
        debouncedOnChange({ filterString: "" });
      } else if (valueNum > ratingMax) {
        debouncedOnChange({ filterString: ratingMax });
      } else if (valueNum < 0) {
        debouncedOnChange({ filterString: 0 });
      } else {
        debouncedOnChange({ filterString: valueNum });
      }
    },
    [ratingMax, debouncedOnChange]
  );

  const handleKeydown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (isInvalidTypedCharForInput(e)) {
      e.preventDefault();
    }
  }, []);

  return (
    <Container>
      <Input.Text
        meta={{}}
        input={{
          name: `${name}.rating`,
          onChange: handleChange,
          value: isNumber(filterString) ? filterString : "",
        }}
        trailing={<Icon icon={glyphs.STAR_V2} />}
        onKeyDown={handleKeydown}
      />
    </Container>
  );
};

export default RatingInput;
